import {
  CompletedStatusIcon,
  ReadyIcon,
  ArchivedIcon,
  CanceledIcon,
  BilledIcon,
  FilledIcon,
  OTCIcon,
  PickupIcon,
  PartnerIcon,
  RedispatchIcon,
} from 'pages/Tracking/icons';
import classNames from 'classnames';
import styles from '../../Tracking.module.scss';
import {TrackingStatus} from 'types';

type BannerConfig = {
  icon: JSX.Element;
  title: string;
  message: string;
};

const BANNER_CONFIG: Record<TrackingStatus, BannerConfig> = {
  completed: {
    icon: <OTCIcon />,
    title: 'Order Received',
    message: 'Your order has been received and will be processed shortly.',
  },
  billed: {
    icon: <BilledIcon />,
    title: 'Order in Progress',
    message: 'Your order is currently being processed.',
  },
  filled: {
    icon: <FilledIcon />,
    title: 'Order in Progress',
    message: 'Your order is currently being processed.',
  },
  otc_status: {
    icon: <OTCIcon />,
    title: 'Order Received',
    message: 'Your order has been received and will be processed shortly.',
  },
  waiting_for_pickup: {
    icon: <PickupIcon />,
    title: 'Ready for Pickup',
    message: 'Your order is ready. Please visit the pharmacy to pick it up.',
  },
  ready_for_delivery: {
    icon: <ReadyIcon />,
    title: 'Ready for Delivery',
    message: 'Your order is ready and will be dispatched shortly',
  },
  delivering: {
    icon: <ReadyIcon />,
    title: 'Delivering',
    message: 'Your order is on its way to you!',
  },
  delivery_partner: {
    icon: <PartnerIcon />,
    title: 'Delivery Partner',
    message: 'Your order will be delivered soon by our delivery partner.',
  },
  picked_up: {
    icon: <CompletedStatusIcon />,
    title: 'Picked Up',
    message: 'Your order has been picked up.',
  },
  delivered: {
    icon: <CompletedStatusIcon />,
    title: 'Delivered',
    message: 'Your order has been successfully delivered. Thank you!',
  },
  cancel_script: {
    icon: <CanceledIcon />,
    title: 'Order Canceled',
    message:
      'Your order has been canceled. Please contact the pharmacy for more information.',
  },
  archive: {
    icon: <ArchivedIcon />,
    title: 'Order Archived',
    message: 'This order has been archived.',
  },
  redispatch: {
    icon: <RedispatchIcon />,
    title: 'Redelivery Scheduled',
    message:
      'Your order has been scheduled for redelivery. We will attempt delivery again soon.',
  },
};

type Props = {
  status: TrackingStatus;
  attempt?: number;
};

const StatusBanner = ({status, attempt}: Props) => {
  const config = BANNER_CONFIG[status];
  const {icon, title, message} = config;

  const displayTitle =
    attempt && attempt > 1 ? `${title} (Attempt #${attempt})` : title;

  return (
    <div
      className={classNames(
        styles.statusBanner,
        styles[status.replaceAll('_', '')]
      )}
    >
      <div className={styles.statusBannerIcon}>{icon}</div>
      <h2 className={styles.statusBannerTitle}>{displayTitle}</h2>
      <p className={styles.statusBannerMessage}>{message}</p>
    </div>
  );
};

export default StatusBanner;
